import moment from "moment";
import React, { useState } from "react";
import "react-calendar/dist/Calendar.css";
import { Value } from "react-calendar/dist/cjs/shared/types";
import "../../sass/components/Filters/ProjectDeadlineFilter.scss";
import Calender from "../Calender/Calender";

export default function ProjectDeadlineFilter({
  dateState,
  setDateState,
  open,
  setOpen,
  title = "Willing to Collab Until",
  isAdd,
}: {
  dateState: Date;
  setDateState: (newState: Date) => void;
  open: boolean;
  setOpen: (key: string) => void;
  title?: string;
  isAdd: boolean;
}) {
  // const [open, setOpen] = useState<boolean>(false);
  const [date, setDate] = useState<boolean | null>(null);
  // const [dateState, setDateState] = useState<Date | null>(null);
  const [titleCount, setTitleCount] = useState<number>(0);
  const handleOpen = () => {
    setOpen("projectDeadline");
  };
  const handleCalender = () => {
    setDate(!date);
  };
  const changeDate = (
    e: Value,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setDateState(e as Date);
  };

  const formattedDate = dateState ? (
    new Date(dateState).toLocaleDateString("en-GB")
  ) : (
    <div className="dddddd">
      <small> DD / MM / YYYY</small>
      <p>
        {date ? (
          <i className="fas fa-angle-up"></i>
        ) : (
          <i className="fas fa-angle-down "></i>
        )}
      </p>
    </div>
  );

  return (
    <div className="component set_border_2_grey">
      <div onClick={handleOpen} className="title">
        <p>
          {title}&nbsp;
          {dateState && (
            <span className="ml_3">
              ({new Date(dateState).toLocaleDateString("en-GB")})
            </span>
          )}
        </p>
        <i
          className={`${
            open && "rotate"
          } fa-solid fa-chevron-down cursor-pointer`}
        />
      </div>
      {open && (
        <div
          className="show_component"
          style={
            isAdd
              ? { left: 0, right: 0, borderLeft: 0, borderRight: 0 }
              : undefined
          }
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              gap: "8px",
              alignItems: "center",
              justifyContent: "center",
              padding: "8px 0",
            }}
          >
            <div
              onClick={handleCalender}
              className="date_btn"
              style={{
                minWidth: 120,
                maxWidth: 120,
                padding: "6px 8px",
                border: "1px solid #ddd",
                borderRadius: "6px",
                background: "#fff",
                cursor: "pointer",
                fontSize: "11px",
                height: "28px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {formattedDate}
            </div>
          </div>
          {date && (
            <div className="calender_design">
              <Calender
                selectedDate={dateState}
                handleDateChange={changeDate}
                minDate={moment().add(1, "day")}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
